<script generics="TItem">import { mdiChevronRight } from "@mdi/js";
import Icon from "./Icon.svelte";
import { cls } from "../utils/styles.js";
import { getComponentClasses } from "./theme.js";
export let items = [];
export let divider = void 0;
export let inline = false;
let className = void 0;
export { className as class };
const settingsClasses = getComponentClasses("Breadcrumb");
$: displayItems = items?.filter((x) => x != null) ?? [];
</script>

<div
  {...$$restProps}
  class={cls(
    'Breadcrumb',
    inline ? 'inline-flex' : 'flex',
    'items-center justify-start flex-wrap',
    settingsClasses.root,
    className
  )}
>
  {#each displayItems as item, index}
    <slot name="item" {item}>
      <div class="item">{item}</div>
    </slot>

    {#if index < displayItems.length - 1}
      <slot name="divider">
        {#if divider}
          <div class="divider opacity-25">{divider}</div>
        {:else}
          <Icon data={mdiChevronRight} class="divider opacity-25" />
        {/if}
      </slot>
    {/if}
  {/each}
</div>
